/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React, { memo, useMemo } from 'react';

import { EntityItemSkeleton } from '../../skeletons/EntityItemSkeleton';
import { getDummyArray } from '../../utils/getDummyArray';
import { useEntitiesListStyles } from './EntitiesList.styles';

export type EntitiesListProps = {
  noItemsTitle?: string | React.ReactNode;
  isLoading: boolean;
  isEmpty: boolean;
  className?: string;
  children: React.ReactElement<any> | React.ReactElement<any>[];
  numberOfSkeletons?: number;
};

export const EntitiesList = memo<EntitiesListProps>(props => {
  const { className = '', children, noItemsTitle, isLoading, isEmpty, numberOfSkeletons = 2 } = props;
  const classes = useEntitiesListStyles();

  const dummySkeletonsArray = useMemo(() => getDummyArray({ length: numberOfSkeletons }), [numberOfSkeletons]);

  return (
    <div className={cx(classes.root, { [className]: className })}>
      {isLoading
        ? dummySkeletonsArray.map(i => (
            <div key={i} className={classes.itemWrap}>
              <EntityItemSkeleton />
            </div>
          ))
        : isEmpty && noItemsTitle
          ? noItemsTitle
          : children}
    </div>
  );
});
